var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('img',{attrs:{"src":require("../assets/404.png"),"alt":"404 Not Found Image"}}),_c('p',[_vm._v("抱歉，页面未找到")])])
}]

export { render, staticRenderFns }